import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Limpia',
    desc: 'Eliminas los 3 villanos inflamatorios de tu alacena hoy mismo.'
  }, {
    num: '2',
    title: 'Nutre',
    desc: 'Aplicas el Plato Ancestral en tus próximas 21 comidas (7 días).'
  }, {
    num: '3',
    title: 'Descansa',
    desc: 'Implementas el ritual nocturno para enfriar tu cuerpo antes de dormir.'
  }];
  return <SectionWrapper data-id="element-95">
      <div className="max-w-4xl mx-auto" data-id="element-96">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-brand-brown mb-16" data-id="element-97">
          Cómo funciona
        </h2>

        <div className="relative" data-id="element-98">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-brand-surface -translate-y-1/2 z-0" data-id="element-99"></div>

          <div className="grid md:grid-cols-3 gap-12 relative z-10" data-id="element-100">
            {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-101">
                <div className="w-20 h-20 bg-brand-terracotta text-white rounded-full flex items-center justify-center font-serif text-3xl font-bold mb-6 shadow-lg border-4 border-brand-sand" data-id="element-102">
                  {step.num}
                </div>
                <h3 className="font-serif text-2xl font-bold text-brand-brown mb-3" data-id="element-103">
                  {step.title}
                </h3>
                <p className="font-sans text-brand-brown/80 text-lg leading-relaxed" data-id="element-104">
                  {step.desc}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </SectionWrapper>;
}